








import { Component, Vue } from 'vue-property-decorator'
import InputWithLabel from '@/components/molecules/InputWithLabel.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

@Component({
  components: {
    InputWithLabel,
    ButtonBase,
  },
})
export default class Login extends Vue {
  private toggleBodyClass(addRemoveClass: string, className: string): void {
    const el = document.body

    if (addRemoveClass === 'addClass') {
      el.classList.add(className)
    } else {
      el.classList.remove(className)
    }
  }

  private mounted(): void {
    this.toggleBodyClass('addClass', 'teacher')
  }

  private destroyed(): void {
    this.toggleBodyClass('removeClass', 'teacher')
  }
}
